import React, { useEffect, useState } from 'react';

const ProfileRow = ({ label, value }) => (
    <div className="profile-info-row">
        <span>{label}</span>
        <strong>{value || 'Not added'}</strong>
    </div>
);

const PersonalInfo = ({
    birthday,
    handleProfileEdit,
    isLoggedInUser,
    city,
    state,
    country,
}) => {
    const [editMode, setEditMode] = useState(false);
    const [birthdayInput, setBirthdayInput] = useState(birthday || '');
    const [cityInput, setCityInput] = useState(city || '');
    const [stateInput, setStateInput] = useState(state || '');
    const [countryInput, setCountryInput] = useState(country || '');
    const [error, setError] = useState('');

    useEffect(() => {
        setBirthdayInput(birthday || '');
        setCityInput(city || '');
        setStateInput(state || '');
        setCountryInput(country || '');
    }, [birthday, city, state, country]);

    const handleCancelEdit = () => {
        setEditMode(false);
        setBirthdayInput(birthday || '');
        setCityInput(city || '');
        setStateInput(state || '');
        setCountryInput(country || '');
        setError('');
    };

    const handleSave = async () => {
        setError('');
        try {
            await handleProfileEdit({
                birthday: birthdayInput || null,
                city: cityInput,
                state: stateInput,
                country: countryInput,
            });
            setEditMode(false);
        } catch (err) {
            setError(err.response?.data?.detail || 'Unable to save changes.');
        }
    };

    const formatBirthday = (birthdayValue) => {
        if (!birthdayValue) return '';
        const formattedBirthday = new Date(birthdayValue);
        return formattedBirthday.toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            timeZone: 'Europe/London',
        });
    };

    return (
        <section className="profile-card personal-info">
            <div className="profile-card-header">
                <div>
                    <p className="profile-card-kicker">Details</p>
                    <h4>Personal Info</h4>
                </div>
                {isLoggedInUser && !editMode && (
                    <button
                        className="profile-icon-button"
                        type="button"
                        aria-label="Edit personal info"
                        onClick={() => setEditMode(true)}
                    >
                        <i className="bi-pencil-square" />
                    </button>
                )}
            </div>
            {editMode ? (
                <div className="profile-form-grid">
                    <label>
                        Birthday
                        <input
                            className="profile-field"
                            value={birthdayInput}
                            onChange={(e) => setBirthdayInput(e.target.value)}
                            type="date"
                        />
                    </label>
                    <label>
                        City
                        <input
                            className="profile-field"
                            value={cityInput}
                            onChange={(e) => setCityInput(e.target.value)}
                            type="text"
                            placeholder="City"
                        />
                    </label>
                    <label>
                        State
                        <input
                            className="profile-field"
                            value={stateInput}
                            onChange={(e) => setStateInput(e.target.value)}
                            type="text"
                            placeholder="State"
                        />
                    </label>
                    <label>
                        Country
                        <input
                            className="profile-field"
                            value={countryInput}
                            onChange={(e) => setCountryInput(e.target.value)}
                            type="text"
                            placeholder="Country"
                        />
                    </label>
                    <div className="profile-action-row profile-form-wide">
                        <button
                            className="btn profile-secondary-button"
                            type="button"
                            onClick={handleCancelEdit}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn profile-primary-button"
                            type="button"
                            onClick={handleSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            ) : (
                <div className="profile-info-list">
                    <ProfileRow
                        label="Birthday"
                        value={formatBirthday(birthdayInput)}
                    />
                    <ProfileRow
                        label="Location"
                        value={[cityInput, stateInput, countryInput]
                            .filter(Boolean)
                            .join(', ')}
                    />
                </div>
            )}
            {error && <p className="profile-inline-error">{error}</p>}
        </section>
    );
};

export default PersonalInfo;
